// extracted by mini-css-extract-plugin
export var header = "styles-module--header--3LX2L";
export var inner = "styles-module--inner--3U8Dl";
export var about = "styles-module--about--V69Ze";
export var button = "styles-module--button--3YpRP";
export var buttonRotate = "styles-module--buttonRotate--idoUw";